import { memo } from 'react'

const EmptySearchIllustration = memo(function EmptySearchIllustration() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="148 0 65 62"
			fill="none"
			aria-hidden="true"
			style={{ width: 64, height: 64, flexShrink: 0 }}
		>
			<path
				d="M194.49 51.5151H189.557V50.6789H194.464L194.498 51.5151H194.49ZM184.659 51.5151H179.752V50.6789H184.659V51.5151ZM174.846 51.5151H169.939V50.6789H174.846V51.5151ZM165.041 51.5151H164.341C162.643 51.5151 161.252 50.1327 161.244 48.4261H162.08C162.08 49.6634 163.095 50.6789 164.341 50.6789H165.041V51.5151ZM197.553 47.6922H196.717V42.7855H197.553V47.6922ZM162.071 43.5279H161.235V38.6213H162.071V43.5279ZM197.553 37.8874H196.717V32.9807H197.553V37.8874ZM162.071 33.7146H161.235V28.8079H162.071V33.7146ZM197.553 28.0826H196.717V23.1759H197.553V28.0826ZM162.071 23.9098H161.235V19.0031H162.071V23.9098ZM196.725 18.2778C196.717 17.0405 195.701 16.0335 194.464 16.0335H193.747V15.1973H194.464C196.154 15.1973 197.544 16.5711 197.562 18.2607H196.725V18.2778ZM188.84 16.0335H183.934V15.1973H188.84V16.0335ZM179.036 16.0335H174.129V15.1973H179.036V16.0335ZM169.222 16.0335H164.333L164.316 15.2741V15.1973H169.222V16.0335Z"
				fill="#000135"
			/>
			<path
				d="M169.948 39.6297C179.713 39.6297 187.629 31.7136 187.629 21.9486C187.629 12.1837 179.713 4.26758 169.948 4.26758C160.183 4.26758 152.267 12.1837 152.267 21.9486C152.267 31.7136 160.183 39.6297 169.948 39.6297Z"
				fill="white"
			/>
			<path
				d="M169.948 40.0461C159.972 40.0461 151.849 31.9309 151.849 21.9469C151.849 11.9629 159.972 3.84766 169.948 3.84766C179.923 3.84766 188.047 11.9629 188.047 21.9469C188.047 31.9309 179.932 40.0461 169.948 40.0461ZM169.948 4.68392C160.425 4.68392 152.685 12.4237 152.685 21.9469C152.685 31.4701 160.433 39.2098 169.948 39.2098C179.462 39.2098 187.211 31.4615 187.211 21.9469C187.211 12.4322 179.471 4.68392 169.948 4.68392Z"
				fill="#000135"
			/>
			<path
				d="M182.746 34.1528L182.154 34.7441L187.132 39.7222L187.724 39.1308L182.746 34.1528Z"
				fill="#000135"
			/>
			<path
				d="M190.233 36.6247L184.621 42.2363L202.12 59.7349L207.731 54.1233L190.233 36.6247Z"
				fill="black"
			/>
			<path
				d="M187.433 39.4344L184.628 42.2402L202.126 59.7388L204.932 56.933L187.433 39.4344Z"
				fill="#D4D4D4"
			/>
			<path
				d="M202.119 60.323L184.036 42.2408L190.24 36.0371L208.322 54.1192L202.119 60.323ZM185.214 42.2408L202.119 59.1454L207.145 54.1192L190.24 37.2147L185.214 42.2408Z"
				fill="#000135"
			/>
			<path
				d="M177.825 13.4702L161.473 29.8223L162.077 30.4257L178.429 14.0736L177.825 13.4702Z"
				fill="black"
			/>
			<path
				d="M162.077 13.4689L161.473 14.0723L177.825 30.4243L178.429 29.8209L162.077 13.4689Z"
				fill="black"
			/>
		</svg>
	)
})

export default EmptySearchIllustration
